import React, { Component, Fragment } from 'react';
import { Button, Form, Header, Icon, Loader, Segment, SegmentGroup, Grid } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import axios from 'axios';
import { fetchActiveRole, fetchUserOrganizationalUnit } from '../util/roles';
import {
    checkOrganizationalUnitsPrivilege,
    checkWritePrivilege,
    DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
    formatListForDropdownOptions,
    getTotalNumberOfPages
} from '../util/util';

import VehiclesTable from './VehiclesTable';
import VehicleForm from './VehicleForm';
import PaginationSegment from '../util/PaginationSegment';
import { fetchFaculties } from '../../Lookups/util';
import ReactExport from 'react-data-export';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const v = (val) => val != null && val !== '' ? val : '-';

const VEHICLE_COLUMNS = [
    { key: 'organizationalUnitName', displayName: 'Članica', accessor: (el) => el.organizationalUnit && el.organizationalUnit.name },
    { key: 'manufacturerName', displayName: 'Proizvođač', accessor: (el) => el.manufacturer && el.manufacturer.name },
    { key: 'model', displayName: 'Model', accessor: (el) => el.model || '-' },
    { key: 'typeName', displayName: 'Tip', accessor: (el) => el.type && el.type.name },
    { key: 'licencePlate', displayName: 'Tablice', accessor: (el) => el.licencePlate },
    { key: 'chassisNumber', displayName: 'Broj šasije', accessor: (el) => el.chassisNumber },
    { key: 'fuelTypeName', displayName: 'Tip goriva', accessor: (el) => el.fuelType && el.fuelType.name },
    { key: 'numberOfSeats', displayName: 'Broj sjedišta', accessor: (el) => el.numberOfSeats },
    { key: 'productionYear', displayName: 'Godina proizvodnje', accessor: (el) => el.productionYear },
    { key: 'purchaseYear', displayName: 'Godina nabavke', accessor: (el) => el.purchaseYear },
    { key: 'statusName', displayName: 'Status', accessor: (el) => el.status && el.status.name },
    { key: 'value', displayName: 'Vrijednost (BAM)', accessor: (el) => el.value != null ? el.value + ' BAM' : '-' },
];

const sanitize = (val) => {
    if (val == null) return '';
    if (val === '-') return '';
    if (typeof val === 'boolean') return val ? 'Da' : 'Ne';
    return String(val);
};

const SEARCH_FIELDS = ['_searchOrgUnit', '_searchManufacturer', '_searchModel', '_searchLicencePlate', '_searchChassisNumber', '_searchFuelType', '_searchStatus'];

const addSearchFields = (items) => items.map(item => ({
    ...item,
    _searchOrgUnit: item.organizationalUnit && item.organizationalUnit.name ? item.organizationalUnit.name : '',
    _searchManufacturer: item.manufacturer && item.manufacturer.name ? item.manufacturer.name : '',
    _searchModel: item.model ? item.model : '',
    _searchLicencePlate: item.licencePlate ? item.licencePlate : '',
    _searchChassisNumber: item.chassisNumber ? item.chassisNumber : '',
    _searchFuelType: item.fuelType && item.fuelType.name ? item.fuelType.name : '',
    _searchStatus: item.status && item.status.name ? item.status.name : '',
}));

const prepareExcelData = (vehicles) => [{
    columns: VEHICLE_COLUMNS.map(col => ({
        title: col.displayName,
        width: { wpx: 200 }
    })),
    data: vehicles.map(item =>
        VEHICLE_COLUMNS.map(col => ({
            value: sanitize(col.accessor(item))
        }))
    )
}];

class Vehicles extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            vehicles: [],
            allVehicles: [],
            filteredVehicles: [],
            showForm: false,
            editingVehicle: null,
            loader: true,
            organizationalUnitOptions: [],
            selectedOrganizationalUnit: null,
            deletingRowId: null,
            saving: false,
            searchText: '',
            excelData: [],
        };
        this.getUserData = this.getUserData.bind(this);
        this.fetchAllVehicles = this.fetchAllVehicles.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.onCloseForm = this.onCloseForm.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.onChangeOrganizationalUnit = this.onChangeOrganizationalUnit.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                this.setState({
                    activeRole,
                });
                fetchFaculties()
                    .then(response => {
                        this.setState({
                            organizationalUnitOptions: formatListForDropdownOptions(response.data),
                        }, () => this.fetchAllVehicles());
                    })
                    .catch(err => {
                        // console.log('Failed to fetch organizational units.');
                        this.setState({ loader: false });
                    });
            }))
            .catch(err => {
                this.setState({
                    error: true,
                    loader: false
                });
                // console.log('Failed to fetch data.');
            });
    }

    onChangeOrganizationalUnit(selectedOrganizationalUnit) {
        this.setState({ selectedOrganizationalUnit }, () => {
            this.fetchAllVehicles(0, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
        });
    }

    fetchAllVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        this.setState({
            loader: true
        });
        this.fetchVehicles(page, resultsPerPage)
            .then((res) => {
                const vehicles = res.data.responseList;
                const withSearchFields = addSearchFields(vehicles);
                let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                this.setState({
                    vehicles,
                    allVehicles: withSearchFields,
                    filteredVehicles: withSearchFields,
                    excelData: prepareExcelData(withSearchFields),
                    totalPages,
                    loader: false
                });
                this.updateVehicles(page, resultsPerPage, res);
            });
    }


    fetchVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        const organizationalUnitId = this.state.selectedOrganizationalUnit;
        const urlSuffix = organizationalUnitId ? `${organizationalUnitId}/` : '';
        return axios.post('/assets/vehicle/paginated/' + urlSuffix, { ...pagination });
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        this.fetchAllVehicles(activePage - 1, this.state.resultsPerPage);
    }

    updateVehicles(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }

    handleDeleteClick = (id) => {
        this.setState({ deletingRowId: id });
    };

    handleCancelClick = () => {
        this.setState({ deletingRowId: null });
    };

    handleConfirmClick = () => {
        const { deletingRowId } = this.state;
        this.setState({ saving: true });
        axios.delete(`/assets/vehicle/delete/${deletingRowId}`)
            .then(res => {
                toast('Brisanje vozila je uspješno izvršeno.');
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
                this.fetchAllVehicles();
            })
            .catch(err => {
                const msg = err && err.response && err.response.data ? err.response.data : '';
                if (msg.includes('ConstraintViolationException')) {
                    toast(<FormattedMessage id="assets.vehicles.deleteConstraintError"/>);
                } else {
                    toast(<FormattedMessage id="assets.vehicles.deleteError"/>);
                }
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
            });
    };

    getResults = (results) => {
        if (results.length === 0 && this.state.searchText.trim() === '') {
            const withSearchFields = addSearchFields(this.state.vehicles);
            this.setState({
                filteredVehicles: withSearchFields,
                excelData: prepareExcelData(withSearchFields),
            });
        } else {
            this.setState({
                filteredVehicles: results,
                excelData: prepareExcelData(results),
            });
        }
    };

    handleSearchTextChange = (text) => {
        this.setState({ searchText: text });
    };

    onCloseForm() {
        this.setState({
            showForm: false,
            editingVehicle: null
        });
    }

    activateEditRequest(vehicle) {
        this.setState({
            showForm: true,
            editingVehicle: vehicle
        });
    }

    render() {
        const activeRole = localStorage.getItem('activeRole');
        const { vehicles } = this.state;
        return (
            <div>
                <Header as="h1">Vozila</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak vozila
                            {checkWritePrivilege(activeRole) && <Header style={IconHeader} floated="right"> <Button
                                color="blue"
                                floated="right"
                                icon
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                disabled={this.state.showForm}
                                onClick={() => this.setState({
                                    showForm: true,
                                    editingVehicle: null
                                })}
                            ><Icon className="add"/>
                                Dodavanje vozila
                            </Button>
                            </Header>}

                        </Header>
                    </Segment>
                    {this.state.showForm &&
                        <VehicleForm
                            vehicle={this.state.editingVehicle}
                            activeRole={this.state.activeRole}
                            onRefreshData={this.fetchAllVehicles}
                            onCloseForm={this.onCloseForm}
                        />
                    }
                    {checkOrganizationalUnitsPrivilege(activeRole) &&
                        // Only university super admin and university admin can filter by OU
                        <Segment>
                            <Form>
                                <Form.Field>
                                    <label>Članica</label>
                                    <Form.Dropdown
                                        disabled={this.state.loader}
                                        search
                                        options={this.state.organizationalUnitOptions}
                                        value={this.state.selectedOrganizationalUnit || null}
                                        selection
                                        clearable={true}
                                        placeholder={'Odaberite članicu'}
                                        onChange={(e, { value }) => this.onChangeOrganizationalUnit(value)}/>
                                </Form.Field>
                            </Form>
                        </Segment>
                    }
                    <Segment>
                        {this.state.loader ?
                            <Loader active inline="centered"/>
                            : this.state.filteredVehicles && this.state.allVehicles.length ?
                                <Fragment>
                                    <VehiclesTable
                                        disableAction={this.state.showForm}
                                        allVehicles={this.state.allVehicles}
                                        filteredVehicles={this.state.filteredVehicles}
                                        activateEditRequest={this.activateEditRequest}
                                        deletingRowId={this.state.deletingRowId}
                                        saving={this.state.saving}
                                        handleDeleteClick={this.handleDeleteClick}
                                        handleConfirmClick={this.handleConfirmClick}
                                        handleCancelClick={this.handleCancelClick}
                                        excelData={this.state.excelData}
                                        getResults={this.getResults}
                                        handleSearchTextChange={this.handleSearchTextChange}
                                        searchFields={SEARCH_FIELDS}
                                    />
                                    <PaginationSegment
                                        activePage={this.state.activePage}
                                        totalPages={this.state.totalPages}
                                        onPageChange={this.handlePageChange}
                                    />
                                </Fragment>
                                : ('Nema podataka za prikaz.')
                        }
                    </Segment>
                </SegmentGroup>
                <ToastContainer hideProgressBar/>
            </div>
        );
    }
}

export default Vehicles;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/Vehicles.js